export const boolToInt = object => {
  const newObject = {};
  /* eslint-disable array-callback-return */
  Object.keys(object).map(x => {
    newObject[x] = object[x] === true ? 1 : object[x] === false ? 0 : object[x];
  });
  /* eslint-enable array-callback-return */
  return newObject;
};

export const keysToLowerCase = o =>
  Object.keys(o).reduce((c, k) => {
    c[k.toLowerCase()] = o[k];
    return c;
  }, {});



// WEBPACK FOOTER //
// ./src/utils/object.js